import Vue from 'vue'
import router from '../router'
import jwt from 'jwt-decode'
import Vuex from 'vuex';

Vue.use(Vuex)

export default {
    state: {
        profile: null,
        accessToken: null,
        verification: null,
        refreshToken: null,
        isAuthenticated: false,
        count: 0,
        isAdmin: false,
        role: {
            DEVELOPER: 'developer',
            ADMIN: 'admin',
            REVIEWER: 'reviewer'
        },
        userId: null
    },

    getters: {
        profile: state => state.profile,
        verification: state => state.verification,
        accessToken: state => state.accessToken,
        idToken: state => state.idToken,
        refreshToken: state => state.refreshToken,
        isAuthenticated: state => state.isAuthenticated,
        isAdmin: state => state.isAdmin,
        role: state => state.role,
        userId: state => state.userId
    },

    mutations: {
        setProfile: (state, profile) => {
            if (profile && profile !== undefined) {
                state.profile = profile
                if (profile['cognito:groups'].length === 0) {
                    router.push({
                        name: 'error',
                        params: {
                            message: 'No user role assigned'
                        }
                    })
                }
                state.isAdmin = profile['cognito:groups'][0] === 'admin'
                state.role = profile['cognito:groups'][0];
                state.userId = profile.email;
            }
        },
        setAccessToken: (state, accessToken) => {
            state.accessToken = accessToken
        },
        setIdToken: (state, idToken) => {
            state.idToken = idToken
        },
        setRefreshToken: (state, refreshToken) => {
            state.refreshToken = refreshToken
        },
        setVerification: (state, verification) => {
            state.verification = verification
        },
        setAuthenticated: (state, isAuthenticated) => {
            state.isAuthenticated = isAuthenticated
        }
    },

    actions: {
        signout: function (context, payload) {
            console.log(payload)
            context.commit('setProfile', null)
            context.commit('setAccessToken', null)
            context.commit('setAuthenticated', false)
            context.commit('setRefreshToken', null)
            context.commit('reset')
            router.push({
                name: 'index'
            })
        },
        authenticate: function (context, payload) {
            if (payload.idToken === null || (jwt(payload.idToken).token_use || null) !== 'id') {
                router.push({
                    name: 'error',
                    params: {
                        message: 'The authentication response did not include a valid ID token'
                    }
                })
                return
            }
            context.commit('setProfile', jwt(payload.idToken))
            context.commit('setAccessToken', payload.accessToken)
            context.commit('setIdToken', payload.idToken)
            context.commit('setRefreshToken', payload.refreshToken)
            context.commit('setAuthenticated', true)
            context.commit('reset')
            context.commit('setCoachId', jwt(payload.idToken)["custom:coach_id"])
            if (!payload.noRedirect)
                router.push('/')
        }
    }
}